// extracted by mini-css-extract-plugin
export default {"wrapper":"GG","noPadding":"HG","flavor_wrapper":"IG","flavor_button":"JG","vert":"KG","itemContent":"LG","itemName":"MG","blue":"NG","out_of_stock":"OG","newFlavorBadge":"PG","fullWidth":"QG","flavor_button_selected":"RG","black":"SG","attribute_wrapper":"TG","toggle_wrapper":"UG"};
    if(module.hot) {
      // 1730991508099
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  